import type { ProductSizeOption } from '@repo/api-contracts';
import { type ReactElement, useId } from 'react';
import { FormField } from '@/shared/ui';
import type { SizeFieldValues } from '../model/size-allocation';

interface SizeTotalFieldsProps {
  readonly options: readonly ProductSizeOption[];
  readonly values: SizeFieldValues;
  readonly error?: string | undefined;
  readonly disabled?: boolean;
  readonly onChange: (sizeOptionId: string, value: string) => void;
}

export const SizeTotalFields = ({
  options,
  values,
  error,
  disabled = false,
  onChange,
}: SizeTotalFieldsProps): ReactElement => {
  const errorId = useId();
  return (
    <fieldset
      disabled={disabled}
      aria-describedby={error ? errorId : undefined}
      className="min-w-0 space-y-3"
    >
      <legend className="text-sm font-semibold">사이즈별 수량</legend>
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
        {options.map((option) => (
          <FormField
            key={option.id}
            label={option.name}
            inputMode="numeric"
            autoComplete="off"
            placeholder="0"
            value={values[option.id] ?? ''}
            aria-invalid={error ? true : undefined}
            onChange={(event) => onChange(option.id, event.target.value)}
          />
        ))}
      </div>
      {error ? (
        <p id={errorId} role="alert" className="text-xs text-destructive">
          {error}
        </p>
      ) : null}
    </fieldset>
  );
};
